import React from 'react';
import BaseListItemIcon from '@mui/material/ListItemIcon';
import BaseListItemText from '@mui/material/ListItemText';
import BaseMenuItem from '@mui/material/MenuItem';
import { languageCodeToCountryCodeFallback } from '../Languages/Languages.helpers';
import * as S from './Langs.styles';
const languages = [{
  code: 'en',
  label: 'English'
}, {
  code: 'de',
  label: 'Deutsch'
}];
const Langs = ({
  currentLanguage,
  changeLanguage
}) => /*#__PURE__*/React.createElement(React.Fragment, null, languages.map(language => /*#__PURE__*/React.createElement(BaseMenuItem, {
  key: language.code,
  onClick: () => changeLanguage(language.code),
  selected: language.code === currentLanguage
}, /*#__PURE__*/React.createElement(BaseListItemIcon, null, /*#__PURE__*/React.createElement(S.Image, {
  src: `/flags/1x1/${languageCodeToCountryCodeFallback.get(language.code) || language.code}.svg`,
  alt: language.code
})), /*#__PURE__*/React.createElement(BaseListItemText, {
  primary: language.label,
  primaryTypographyProps: {
    variant: 'Lato Emphasized 2'
  }
}))));
export default Langs;